class QuantityInput extends HTMLElement {
	constructor() {
		super();
		this.changeEvent = new Event('change', { bubbles: true });
		this.disabled = this.dataset.disabled === 'true';
		this.elements = {
			button_minus: this.querySelector('button[name="minus"]'),
			button_plus: this.querySelector('button[name="plus"]'),
			input: this.querySelector('input'),
		};
		this.max = parseInt(this.elements.input.max);
		this.min = parseInt(this.elements.input.min);
		this.elements.button_minus.addEventListener('click', this.handleButtonClick.bind(this));
		this.elements.button_plus.addEventListener('click', this.handleButtonClick.bind(this));
		this.elements.input.addEventListener('change', this.handleChange.bind(this));
		this.handleComponentStates();
	}
	handleChange() {
		const input = this.elements.input;
		const inputMax = Math.max(this.max ?? 0, 0);
		if (input.value > inputMax) {
			input.value = inputMax;
		}
	}
	handleComponentStates() {
		const { input, button_minus, button_plus } = this.elements;
		const value = parseInt(input.value);
		input.disabled = this.disabled;
		button_minus.disabled = this.disabled || value <= this.min;
		button_plus.disabled = this.disabled || value >= this.max;
	}
	handleButtonClick(event) {
		event.preventDefault();
		const input = this.elements.input;
		const previousValue = input.value;
		switch (event.target) {
			case this.elements.button_plus:
				input.stepUp();
				break;
			case this.elements.button_minus:
				input.stepDown();
				break;
		}
		if (previousValue !== input.value) {
			input.dispatchEvent(this.changeEvent);
		}
		this.handleComponentStates();
	}
	setMax(max) {
		const input = this.elements.input;
		if (max < 0 || !input) {
			return;
		}
		input.max = max;
		this.max = max;
		if (input.value > max) {
			input.value = max;
		}
		this.handleComponentStates();
	}
	setState(enabled) {
		this.disabled = !enabled;
		this.dataset.disabled = !enabled;
		this.handleComponentStates();
	}
}

if (!customElements.get('quantity-input')) {
	customElements.define('quantity-input', QuantityInput);
}
